// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .label-form-container {
    padding: 1rem;
  }
}
.label-form-container .label-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.label-form-container .label-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.label-form-container .label-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-label-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.label-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: label-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .label-form-card {
    padding: 1rem;
    width: 100%;
  }
}
.label-form-card .label-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .label-form-card .label-form-title {
    font-size: 1.25rem;
  }
}
.label-form-card .label-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.label-form-card .form-section {
  margin-bottom: 1.5rem;
}
.label-form-card .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.label-form-card .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.label-form-card .label-form-group,
.label-form-card .form-group {
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
}
.label-form-card .label-form-group:last-child,
.label-form-card .form-group:last-child {
  margin-bottom: 0;
}
.label-form-card .label-form-group .label-form-label,
.label-form-card .label-form-group label,
.label-form-card .form-group .label-form-label,
.label-form-card .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.label-form-card .label-form-group .label-form-label .label-form-required,
.label-form-card .label-form-group label .label-form-required,
.label-form-card .form-group .label-form-label .label-form-required,
.label-form-card .form-group label .label-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.label-form-card .label-form-input,
.label-form-card .label-form-form-select,
.label-form-card .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.label-form-card .label-form-input:focus,
.label-form-card .label-form-form-select:focus,
.label-form-card .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.label-form-card .label-form-input:hover:not(:focus),
.label-form-card .label-form-form-select:hover:not(:focus),
.label-form-card .custom-dropdown-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.label-form-card .label-form-input::placeholder,
.label-form-card .label-form-form-select::placeholder,
.label-form-card .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.label-form-card .label-form-input:disabled,
.label-form-card .label-form-form-select:disabled,
.label-form-card .custom-dropdown-input:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.label-form-card .label-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.label-form-card .label-form-flex-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .label-form-card .label-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.label-form-card .label-form-flex-row .label-form-col-half {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-label .label-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:focus,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:hover:not(:focus),
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:hover:not(:focus) {
  border-color: #9ca3af;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input::placeholder,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select::placeholder {
  color: #9ca3af;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-input:disabled,
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.label-form-card .label-form-flex-row .label-form-col-half .label-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.label-form-card .case-selector {
  position: relative;
}
.label-form-card .case-selector .selected-cases-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb;
  min-height: 2.5rem;
}
.label-form-card .case-selector .selected-cases-tags .case-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.high-court {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #f59e0b;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.high-court:hover {
  background-color: #fde68a;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.district-court {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #3b82f6;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.district-court:hover {
  background-color: #bfdbfe;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.other-court {
  background-color: #f3e8ff;
  color: #7c3aed;
  border: 1px solid #8b5cf6;
}
.label-form-card .case-selector .selected-cases-tags .case-tag.other-court:hover {
  background-color: #e9d5ff;
}
.label-form-card .case-selector .selected-cases-tags .case-tag button {
  background: none;
  border: none;
  color: currentColor;
  cursor: pointer;
  font-size: 1rem;
  padding: 0;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.7;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .selected-cases-tags .case-tag button:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.1);
}
.label-form-card .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.label-form-card .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.label-form-card .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.label-form-card .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.label-form-card .case-selector .dropdown-content .loading-state,
.label-form-card .case-selector .dropdown-content .no-results,
.label-form-card .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.label-form-card .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.label-form-card .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.label-form-card .color-palette-container {
  width: 100%;
}
.label-form-card .color-palette-container .color-palette {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  gap: 8px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  max-height: 300px;
  overflow-y: auto;
}
.label-form-card .color-palette-container .color-palette .color-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}
.label-form-card .color-palette-container .color-palette .color-circle:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.label-form-card .color-palette-container .color-palette .color-circle.selected {
  border-color: #333;
  transform: scale(1.15);
}
.label-form-card .color-palette-container .color-palette .color-circle[style*=ffffff], .label-form-card .color-palette-container .color-palette .color-circle[style*=FFFFFF], .label-form-card .color-palette-container .color-palette .color-circle[style*=fafafa], .label-form-card .color-palette-container .color-palette .color-circle[style*=FAFAFA] {
  border: 1px solid #ddd;
}
.label-form-card .color-palette-container .selected-color-display {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}
.label-form-card .color-palette-container .selected-color-display .selected-color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.label-form-card .color-palette-container .selected-color-display .selected-color-code {
  font-family: monospace;
  font-weight: 500;
  color: #495057;
}
.label-form-card .color-picker .color-gradient {
  position: relative;
  height: 120px;
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}
.label-form-card .color-picker .color-gradient .selector-circle {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: 2px solid #ffffff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}
.label-form-card .color-picker .color-controls {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.75rem;
}
.label-form-card .color-picker .color-controls .color-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #e5e7eb;
  flex-shrink: 0;
}
.label-form-card .color-picker .color-controls .color-slider {
  flex-grow: 1;
  height: 20px;
  background: linear-gradient(to right, red, orange, yellow, green, cyan, blue, violet);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  border: 1px solid #e5e7eb;
}
.label-form-card .color-picker .color-controls .color-slider .slider-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #d1d5db;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.label-form-card .label-form-button-container {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .label-form-card .label-form-button-container {
    flex-direction: column;
  }
}
.label-form-card .label-form-button-container .label-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .label-form-card .label-form-button-container .label-form-btn {
    width: 100%;
  }
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:focus {
  outline: none;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:hover {
  background-color: #005a9a;
}
.label-form-card .label-form-button-container .label-form-btn.label-form-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.label-form-card .label-form-button-container .label-form-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.label-form-card .label-form-button-container .label-form-btn-cancel:hover {
  background-color: #f8f9fa;
}

.modal-label-form-card {
  border: none;
  width: 100% !important;
}
.modal-label-form-card .modal-label-form-title {
  font-size: 1.3rem !important;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}

.exp-service-modal-body h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  text-align: center;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  height: 2.5rem;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .new-service-input::placeholder {
  color: #9ca3af;
}
.exp-service-modal-body .submit-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transform: translateX(10.7rem);
}
.exp-service-modal-body .submit-btn:hover {
  background-color: #005a9a;
}
.exp-service-modal-body .submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

@keyframes label-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .label-form-container .label-form-card {
    width: 100%;
  }
  .color-palette-container .color-palette {
    grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));
    gap: 6px;
  }
  .color-palette-container .color-palette .color-circle {
    width: 35px;
    height: 35px;
  }
}
/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD PRIORITY" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index to appear above the main form modal */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: label-form-fade-in 0.2s ease-out; /* Re-using existing animation */
}
.confirmation-modal.notinvoice {
  width: 420px; /* Specific width for the small modal */
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.confirmation-actions.notinvoice {
  padding-top: 0; /* No extra padding needed for this simple modal */
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none; /* Override default h3 styling within the form */
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/forms/LabelForm/LabelForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAGE;EAXF;IAYI,aAAA;EAAF;AACF;AAIE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAFJ;AAKI;EACE,yBAAA;EACA,cAAA;AAHN;AAOI;EACE,aAAA;EACA,6CAAA;AALN;;AAWA;EACE,wBAAA;EACA,gBAAA;AARF;;AAaA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,2CAAA;EACA,UAAA;AAVF;AAaE;EAVF;IAWI,aAAA;IACA,WAAA;EAVF;AACF;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAZJ;AAeI;EARF;IASI,kBAAA;EAZJ;AACF;AAiBE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAfJ;AAoBE;EACE,qBAAA;AAlBJ;AAqBI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAnBN;AAuBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AArBN;AA2BE;;EAEE,qBAAA;EACA,aAAA;EACA,sBAAA;AAzBJ;AA4BI;;EACE,gBAAA;AAzBN;AA6BI;;;;EAEE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAzBN;AA4BM;;;;EACE,cAAA;EACA,oBAAA;AAvBR;AA8BE;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA5BJ;AA+BI;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3BN;AA+BI;;;EACE,qBAAA;AA3BN;AA+BI;;;EACE,cAAA;AA3BN;AA+BI;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA3BN;AAgCE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA9BJ;AAmCE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAjCJ;AAoCI;EANF;IAOI,sBAAA;IACA,WAAA;EAjCJ;AACF;AAoCI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAlCN;AAqCM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAnCR;AAsCQ;EACE,cAAA;EACA,oBAAA;AApCV;AAyCM;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAvCR;AA0CQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAvCV;AA2CQ;;EACE,qBAAA;AAxCV;AA4CQ;;EACE,cAAA;AAzCV;AA6CQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA1CV;AA+CM;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA7CR;AAoDE;EACE,kBAAA;AAlDJ;AAsDI;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AApDN;AAuDM;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AArDR;AAwDQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAtDV;AAyDU;EACE,yBAAA;AAvDZ;AA4DQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA1DV;AA6DU;EACE,yBAAA;AA3DZ;AAgEQ;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA9DV;AAiEU;EACE,yBAAA;AA/DZ;AAoEQ;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAlEV;AAqEU;EACE,UAAA;EACA,0CAAA;EACA,qBAAA;AAnEZ;AA2EI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AA1EN;AA6EM;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA3ER;AA8EQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA5EV;AA+EU;EACE,mBAAA;EACA,cAAA;AA7EZ;AAiFU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AA/EZ;AAqFM;EACE,iBAAA;EACA,gBAAA;AAnFR;AAsFQ;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AApFV;AAuFU;EACE,mBAAA;AArFZ;AAyFU;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAvFZ;AA0FY;EACE,gBAAA;AAxFd;AA8FY;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA5Fd;AAgGY;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AA/Fd;AAmGY;EACE,kBAAA;EACA,cAAA;AAjGd;AAuGQ;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AArGV;AA0GM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAxGR;AA4GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA1GR;AA6GQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AA3GV;AAoHE;EACE,WAAA;AAlHJ;AAqHI;EACE,aAAA;EACA,2DAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAnHN;AAsHM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AApHR;AAuHQ;EACE,qBAAA;EACA,wCAAA;AArHV;AAyHQ;EACE,kBAAA;EACA,sBAAA;AAvHV;AA6HQ;EAIE,sBAAA;AA9HV;AAoII;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAlIN;AAqIM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAnIR;AAuIM;EACE,sBAAA;EACA,gBAAA;EACA,cAAA;AArIR;AA6II;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3IN;AA8IM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,wCAAA;AA5IR;AAiJI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA/IN;AAkJM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AAhJR;AAoJM;EACE,YAAA;EACA,YAAA;EACA,qFAAA;EAQA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAzJR;AA4JQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,gCAAA;EACA,wCAAA;EACA,eAAA;AA1JV;AAkKE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAhKJ;AAmKI;EARF;IASI,sBAAA;EAhKJ;AACF;AAmKI;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAjKN;AAoKM;EAXF;IAYI,WAAA;EAjKN;AACF;AAoKM;EACE,sCAAA;EACA,YAAA;AAlKR;AAqKQ;EACE,aAAA;AAnKV;AAqKQ;EACE,yBAAA;AAnKV;AAuKQ;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AArKV;AA4KI;EACI,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA1KR;AA6KQ;EACE,yBAAA;AA3KV;;AAkLA;EACE,YAAA;EACA,sBAAA;AA/KF;AAkLE;EACE,4BAAA;AAhLJ;;AAuLE;EA0BE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA7MJ;AAgNI;EACE,cAAA;EACA,yBAAA;AA9MN;;AA4NE;EAKE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA7NJ;AAiOE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA/NJ;AAkOI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhON;AAoOI;EACE,cAAA;AAlON;AAuOE;EA8BE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AAlQJ;AAoQI;EACE,yBAAA;AAlQN;AAsQI;EACE,yBAAA;EACA,mBAAA;AApQN;;AA2QA;EACE;IACE,UAAA;IACA,2BAAA;EAxQF;EA4QA;IACE,UAAA;IACA,wBAAA;EA1QF;AACF;AA8QA;EACE;IACE,UAAA;IACA,2BAAA;EA5QF;EAgRA;IACE,UAAA;IACA,wBAAA;EA9QF;AACF;AAmRA;EACE,UAAA;AAjRF;;AAqRA;EACE,mBAAA;EACA,kBAAA;AAlRF;;AAsRA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAnRF;;AAuRA;EAGE,mBAAA;AAtRF;;AA2RA;EAEI;IACE,WAAA;EAzRJ;EA+RE;IACE,2DAAA;IACA,QAAA;EA7RJ;EAgSI;IACE,WAAA;IACA,YAAA;EA9RN;AACF;AAoSA,gEAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,uDAAA;EACA,aAAA;EACA,sBAAA;AAnSF;;AAsSA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA,EAAA,gCAAA;AAnSF;AAqSE;EACE,YAAA,EAAA,uCAAA;AAnSJ;;AAuSA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AApSF;AAsSE;EACE,cAAA,EAAA,kDAAA;AApSJ;AAuSE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AArSJ;AAuSI;;EACE,mBAAA;EACA,YAAA;AApSN;AAwSE;EACE,gCAAA;EACA,YAAA;AAtSJ;AAwSI;EACE,uBAAA;AAtSN;AAySI;EACE,yBAAA;EACA,cAAA;AAvSN;AA2SE;EACE,mBAAA;EACA,YAAA;AAzSJ;AA2SI;EACE,mBAAA;AAzSN;;AA+SA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5SF;AA8SE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA,EAAA,gDAAA;EACA,iBAAA;AA5SJ;AA+SE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AA7SJ;AA+SI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA7SN","sourcesContent":["// Main Container - Match ExpenseForm structure\r\n.label-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n\r\n  // Close button for modal\r\n  .label-form-close-button {\r\n    position: absolute;\r\n    top: 1rem;\r\n    right: 1rem;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n    transition: all 0.2s ease;\r\n\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n      color: #374151;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      outline: none;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.modal-label-form-container {\r\n  padding: 0rem !important;\r\n  min-height: auto;\r\n}\r\n\r\n\r\n// Form Wrapper - Match ExpenseForm card structure\r\n.label-form-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  animation: label-form-fade-in 0.3s ease-out;\r\n  width: 70%;\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n    width: 100%;\r\n  }\r\n\r\n\r\n  // Title styling\r\n  .label-form-title {\r\n    font-size: 1.3rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 1.25rem;\r\n    }\r\n  }\r\n\r\n\r\n  // Divider styling\r\n  .label-form-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n\r\n  // Form sections\r\n  .form-section {\r\n    margin-bottom: 1.5rem;\r\n\r\n\r\n    &:last-of-type {\r\n      border-bottom: none;\r\n      margin-bottom: 0;\r\n      padding-bottom: 0;\r\n    }\r\n\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n    }\r\n  }\r\n\r\n\r\n  // Form groups\r\n  .label-form-group,\r\n  .form-group {\r\n    margin-bottom: 0.5rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n\r\n    .label-form-label,\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n\r\n      .label-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Input and select styling\r\n  .label-form-input,\r\n  .label-form-form-select,\r\n  .custom-dropdown-input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: inherit;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n\r\n    &:hover:not(:focus) {\r\n      border-color: #9ca3af;\r\n    }\r\n\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n\r\n\r\n    &:disabled {\r\n      background-color: #f9fafb;\r\n      color: #6b7280;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n\r\n  .label-form-form-select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n    background-position: right 0.5rem center;\r\n    background-repeat: no-repeat;\r\n    background-size: 1.5rem 1.5rem;\r\n    padding-right: 2.5rem;\r\n  }\r\n\r\n\r\n  // Two column layout for label form\r\n  .label-form-flex-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 0.5rem;\r\n\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n\r\n    .label-form-col-half {\r\n      flex: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n\r\n\r\n      .label-form-label {\r\n        display: block;\r\n        margin-bottom: 0.5rem;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        color: #374151;\r\n\r\n\r\n        .label-form-required {\r\n          color: #ef4444;\r\n          margin-left: 0.25rem;\r\n        }\r\n      }\r\n\r\n\r\n      .label-form-input,\r\n      .label-form-form-select {\r\n        width: 100%;\r\n        padding: 0.5rem;\r\n        border: 1px solid #d1d5db;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-family: inherit;\r\n        color: #374151;\r\n        background: #ffffff;\r\n        box-sizing: border-box;\r\n        height: 2.5rem;\r\n\r\n\r\n        &:focus {\r\n          outline: none;\r\n          border-color: #3b82f6;\r\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n        }\r\n\r\n\r\n        &:hover:not(:focus) {\r\n          border-color: #9ca3af;\r\n        }\r\n\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n\r\n\r\n        &:disabled {\r\n          background-color: #f9fafb;\r\n          color: #6b7280;\r\n          cursor: not-allowed;\r\n        }\r\n      }\r\n\r\n\r\n      .label-form-form-select {\r\n        appearance: none;\r\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n        background-position: right 0.5rem center;\r\n        background-repeat: no-repeat;\r\n        background-size: 1.5rem 1.5rem;\r\n        padding-right: 2.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Case Selector - Match ExpenseForm exactly\r\n  .case-selector {\r\n    position: relative;\r\n\r\n\r\n    // Selected cases tags\r\n    .selected-cases-tags {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 0.375rem;\r\n      margin-top: 0.75rem;\r\n      padding: 0.75rem;\r\n      background: #f9fafb;\r\n      border-radius: 0.375rem;\r\n      border: 1px solid #e5e7eb;\r\n      min-height: 2.5rem;\r\n\r\n\r\n      .case-tag {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 0.375rem;\r\n        padding: 0.375rem 0.75rem;\r\n        border-radius: 1rem;\r\n        font-size: 0.75rem;\r\n        font-weight: 500;\r\n        transition: all 0.2s ease;\r\n\r\n\r\n        &.high-court {\r\n          background-color: #fef3c7;\r\n          color: #92400e;\r\n          border: 1px solid #f59e0b;\r\n\r\n\r\n          &:hover {\r\n            background-color: #fde68a;\r\n          }\r\n        }\r\n\r\n\r\n        &.district-court {\r\n          background-color: #dbeafe;\r\n          color: #1e40af;\r\n          border: 1px solid #3b82f6;\r\n\r\n\r\n          &:hover {\r\n            background-color: #bfdbfe;\r\n          }\r\n        }\r\n\r\n\r\n        &.other-court {\r\n          background-color: #f3e8ff;\r\n          color: #7c3aed;\r\n          border: 1px solid #8b5cf6;\r\n\r\n\r\n          &:hover {\r\n            background-color: #e9d5ff;\r\n          }\r\n        }\r\n\r\n\r\n        button {\r\n          background: none;\r\n          border: none;\r\n          color: currentColor;\r\n          cursor: pointer;\r\n          font-size: 1rem;\r\n          padding: 0;\r\n          width: 18px;\r\n          height: 18px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          border-radius: 50%;\r\n          opacity: 0.7;\r\n          transition: all 0.2s ease;\r\n\r\n\r\n          &:hover {\r\n            opacity: 1;\r\n            background-color: rgba(255, 255, 255, 0.6);\r\n            transform: scale(1.1);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n    // Dropdown content\r\n    .dropdown-content {\r\n      position: absolute;\r\n      top: 100%;\r\n      left: 0;\r\n      width: 100%;\r\n      background: #ffffff;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.375rem;\r\n      z-index: 1000;\r\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\r\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n      margin-top: 0.25rem;\r\n      overflow: hidden;\r\n      animation: dropdown-fade-in 0.2s ease-out;\r\n\r\n\r\n      .dropdown-tabs {\r\n        display: flex;\r\n        background: #f9fafb;\r\n        border-bottom: 1px solid #e5e7eb;\r\n\r\n\r\n        button {\r\n          flex: 1;\r\n          padding: 0.75rem 1rem;\r\n          border: none;\r\n          background: transparent;\r\n          color: #6b7280;\r\n          font-weight: 500;\r\n          font-size: 0.875rem;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n          border-bottom: 2px solid transparent;\r\n\r\n\r\n          &:hover {\r\n            background: #f3f4f6;\r\n            color: #374151;\r\n          }\r\n\r\n\r\n          &.active {\r\n            background: #ffffff;\r\n            color: #3b82f6;\r\n            font-weight: 600;\r\n            border-bottom-color: #3b82f6;\r\n          }\r\n        }\r\n      }\r\n\r\n\r\n      .dropdown-options {\r\n        max-height: 250px;\r\n        overflow-y: auto;\r\n\r\n\r\n        .dropdown-option {\r\n          padding: 0.75rem 1rem;\r\n          cursor: pointer;\r\n          border-bottom: 1px solid #f3f4f6;\r\n          transition: all 0.2s ease;\r\n\r\n\r\n          &:hover {\r\n            background: #f9fafb;\r\n          }\r\n\r\n\r\n          &.selected {\r\n            background: #eff6ff;\r\n            color: #1e40af;\r\n            border-left: 3px solid #3b82f6;\r\n\r\n\r\n            .case-parties {\r\n              font-weight: 600;\r\n            }\r\n          }\r\n\r\n\r\n          .case-info {\r\n            .case-parties {\r\n              font-weight: 500;\r\n              color: #374151;\r\n              font-size: 0.875rem;\r\n              margin-bottom: 0.25rem;\r\n              line-height: 1.4;\r\n            }\r\n\r\n\r\n            .case-ref {\r\n              font-size: 0.75rem;\r\n              color: #6b7280;\r\n              font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\r\n                \"Liberation Mono\", Menlo, monospace;\r\n              background: #f3f4f6;\r\n              padding: 0.125rem 0.375rem;\r\n              border-radius: 0.25rem;\r\n              display: inline-block;\r\n              margin-bottom: 0.25rem;\r\n            }\r\n\r\n\r\n            .case-number {\r\n              font-size: 0.75rem;\r\n              color: #9ca3af;\r\n            }\r\n          }\r\n        }\r\n\r\n\r\n        .no-data {\r\n          padding: 2rem 1rem;\r\n          text-align: center;\r\n          color: #6b7280;\r\n          font-style: italic;\r\n          font-size: 0.875rem;\r\n        }\r\n      }\r\n\r\n\r\n      .loading-state,\r\n      .no-results,\r\n      .empty-state {\r\n        padding: 2rem 1rem;\r\n        text-align: center;\r\n        color: #6b7280;\r\n        font-style: italic;\r\n        font-size: 0.875rem;\r\n      }\r\n\r\n\r\n      .loading-state {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 0.5rem;\r\n\r\n\r\n        &::before {\r\n          content: '';\r\n          width: 16px;\r\n          height: 16px;\r\n          border: 2px solid #e5e7eb;\r\n          border-top: 2px solid #3b82f6;\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n     \r\n    }\r\n  }\r\n\r\n\r\n  // Color Palette Container\r\n  .color-palette-container {\r\n    width: 100%;\r\n\r\n\r\n    .color-palette {\r\n      display: grid;\r\n      grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));\r\n      gap: 8px;\r\n      padding: 16px;\r\n      background-color: #f8f9fa;\r\n      border-radius: 8px;\r\n      border: 1px solid #e9ecef;\r\n      max-height: 300px;\r\n      overflow-y: auto;\r\n\r\n\r\n      .color-circle {\r\n        width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n        border: 3px solid transparent;\r\n        transition: all 0.2s ease;\r\n        position: relative;\r\n\r\n\r\n        &:hover {\r\n          transform: scale(1.1);\r\n          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n        }\r\n\r\n\r\n        &.selected {\r\n          border-color: #333;\r\n          transform: scale(1.15);\r\n          // box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333;\r\n        }\r\n\r\n\r\n        // Add a subtle border for very light colors\r\n        &[style*=\"ffffff\"],\r\n        &[style*=\"FFFFFF\"],\r\n        &[style*=\"fafafa\"],\r\n        &[style*=\"FAFAFA\"] {\r\n          border: 1px solid #ddd;\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n    .selected-color-display {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n      margin-top: 12px;\r\n      padding: 8px;\r\n      background-color: #fff;\r\n      border-radius: 4px;\r\n      border: 1px solid #e9ecef;\r\n\r\n\r\n      .selected-color-preview {\r\n        width: 24px;\r\n        height: 24px;\r\n        border-radius: 4px;\r\n        border: 1px solid #ddd;\r\n      }\r\n\r\n\r\n      .selected-color-code {\r\n        font-family: monospace;\r\n        font-weight: 500;\r\n        color: #495057;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Color Picker Styling\r\n  .color-picker {\r\n    .color-gradient {\r\n      position: relative;\r\n      height: 120px;\r\n      width: 100%;\r\n      margin-bottom: 1rem;\r\n      border-radius: 0.375rem;\r\n      overflow: hidden;\r\n      cursor: pointer;\r\n      border: 1px solid #e5e7eb;\r\n\r\n\r\n      .selector-circle {\r\n        position: absolute;\r\n        width: 16px;\r\n        height: 16px;\r\n        background-color: transparent;\r\n        border: 2px solid #ffffff;\r\n        border-radius: 50%;\r\n        transform: translate(-50%, -50%);\r\n        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\r\n      }\r\n    }\r\n\r\n\r\n    .color-controls {\r\n      display: flex;\r\n      align-items: center;\r\n      margin-bottom: 1rem;\r\n      gap: 0.75rem;\r\n\r\n\r\n      .color-circle {\r\n        width: 32px;\r\n        height: 32px;\r\n        border-radius: 50%;\r\n        border: 2px solid #ffffff;\r\n        box-shadow: 0 0 0 1px #e5e7eb;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n\r\n      .color-slider {\r\n        flex-grow: 1;\r\n        height: 20px;\r\n        background: linear-gradient(to right,\r\n            red,\r\n            orange,\r\n            yellow,\r\n            green,\r\n            cyan,\r\n            blue,\r\n            violet);\r\n        border-radius: 10px;\r\n        position: relative;\r\n        cursor: pointer;\r\n        border: 1px solid #e5e7eb;\r\n\r\n\r\n        .slider-handle {\r\n          position: absolute;\r\n          width: 20px;\r\n          height: 20px;\r\n          background-color: #ffffff;\r\n          border-radius: 50%;\r\n          border: 2px solid #d1d5db;\r\n          top: 50%;\r\n          transform: translate(-50%, -50%);\r\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Form actions to match ExpenseForm\r\n  .label-form-button-container {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n\r\n    .label-form-btn {\r\n      padding: 0.75rem 1.5rem;\r\n      border: none;\r\n      border-radius: 0.375rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      cursor: pointer;\r\n      min-width: 120px;\r\n      transition: all 0.2s ease;\r\n\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n\r\n\r\n      &.label-form-btn-save {\r\n        background-color: var(--primary-color);\r\n        color: white;\r\n\r\n\r\n        &:focus {\r\n          outline: none;\r\n        }\r\n        &:hover{\r\n          background-color: #005a9a;\r\n        }\r\n\r\n\r\n        &:disabled {\r\n          background-color: #d1d5db;\r\n          color: #9ca3af;\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n\r\n\r\n     \r\n    }\r\n    .label-form-btn-cancel {\r\n        padding: 8px 16px;\r\n        border: 1px solid #ddd;\r\n        background: white;\r\n        color: #666;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n\r\n\r\n        &:hover {\r\n          background-color: #f8f9fa;\r\n        }\r\n      }\r\n  }\r\n}\r\n\r\n\r\n.modal-label-form-card {\r\n  border: none;\r\n  width: 100% !important;\r\n\r\n\r\n  .modal-label-form-title {\r\n    font-size: 1.3rem !important;\r\n  }\r\n}\r\n\r\n\r\n// Modal styles\r\n.client-modal-header {\r\n  .close-cross {\r\n    // background: none;\r\n    // border: none;\r\n    // font-size: 1.5rem;\r\n    // color: #6b7280;\r\n    // cursor: pointer;\r\n    // padding: 0;\r\n    // width: 2rem;\r\n    // height: 2rem;\r\n    // display: flex;\r\n    // align-items: center;\r\n    // justify-content: center;\r\n    // border-radius: 0.25rem;\r\n    // transition: all 0.2s ease;\r\n\r\n\r\n    // &:hover {\r\n    //   color: #374151;\r\n    //   background-color: #f3f4f6;\r\n    // }\r\n\r\n\r\n    // &:focus {\r\n    //   outline: none;\r\n    //   box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    // }\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.5rem;\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 0.25rem;\r\n\r\n\r\n    &:hover {\r\n      color: #374151;\r\n      background-color: #f3f4f6;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.exp-service-modal-body {\r\n  //padding: 1.5rem;\r\n  //justify-content: end;\r\n  // display: flex;\r\n  // flex-direction: column;\r\n  // align-items: flex-end;\r\n\r\n\r\n  h3 {\r\n    // font-size: 1.25rem;\r\n    // font-weight: 500;\r\n    // color: #374151;\r\n    // margin: 0 0 1rem 0;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    color: #374151;\r\n    margin: 0 0 1rem 0;\r\n    text-align: center;\r\n  }\r\n\r\n\r\n  .new-service-input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    margin-bottom: 1rem;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n\r\n  .submit-btn {\r\n    // background-color: #16a34a;\r\n    // color: white;\r\n    // border: none;\r\n    // padding: 0.75rem 1.5rem;\r\n    // border-radius: 0.375rem;\r\n    // font-size: 0.875rem;\r\n    // font-weight: 500;\r\n    // cursor: pointer;\r\n    // min-width: 120px;\r\n    // transition: all 0.2s ease;\r\n\r\n\r\n    // &:hover:not(:disabled) {\r\n    //   background-color: #15803d;\r\n    // }\r\n\r\n\r\n    // &:focus {\r\n    //   outline: none;\r\n    //   box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n    // }\r\n\r\n\r\n    // &:disabled {\r\n    //   background-color: #d1d5db;\r\n    //   color: #9ca3af;\r\n    //   cursor: not-allowed;\r\n    //   opacity: 0.6;\r\n    // }\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transform: translateX(10.7rem);\r\n   \r\n    &:hover {\r\n      background-color: #005a9a;\r\n    }\r\n\r\n\r\n    &:disabled {\r\n      background-color: #9ca3af;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Animations\r\n@keyframes label-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n@keyframes dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n// Scrollbar styling for dropdown\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n\r\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n\r\n.case-selector\r\n  .dropdown-content\r\n  .dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n\r\n// Responsive design improvements\r\n@media (max-width: 768px) {\r\n  .label-form-container {\r\n    .label-form-card {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n\r\n  .color-palette-container {\r\n    .color-palette {\r\n      grid-template-columns: repeat(auto-fill, minmax(35px, 1fr));\r\n      gap: 6px;\r\n\r\n\r\n      .color-circle {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD PRIORITY\" MODAL */\r\n\r\n.confirmation-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1050; /* Higher z-index to appear above the main form modal */\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.confirmation-modal {\r\n  background: #ffffff;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  max-width: 95%;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  border: 1px solid #e5e7eb;\r\n  position: relative;\r\n  animation: label-form-fade-in 0.2s ease-out; /* Re-using existing animation */\r\n\r\n  &.notinvoice {\r\n    width: 420px; /* Specific width for the small modal */\r\n  }\r\n}\r\n\r\n.confirmation-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n\r\n  &.notinvoice {\r\n    padding-top: 0; /* No extra padding needed for this simple modal */\r\n  }\r\n\r\n  .confirm-btn,\r\n  .cancel-btn {\r\n    padding: 8px 18px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 80px;\r\n\r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n\r\n  .confirm-btn {\r\n    background: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      filter: brightness(95%);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #d1d5db;\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background: #6b7280;\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      background: #4b5563;\r\n    }\r\n  }\r\n}\r\n\r\n// Styles for the content within the new modal\r\n.add-new-field-modal-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n\r\n  h3 {\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    margin: 0;\r\n    text-align: left;\r\n    border-bottom: none; /* Override default h3 styling within the form */\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .add-new-field-input {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    box-sizing: border-box;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
